<template>
    <div class="applicationCenter-wrap">
        <div class="applicationCenter">
            <div class="applicationCenter-item">
                <div class="applicationCenter-item-top">
                    <div class="applicationCenter-item-top1">
                        <div class="common-title1"></div>
                        <div class="common-title2">应用中心</div>
                        <div class="common-title3">Application center</div>
                    </div>
                </div>
                <div class="applicationCenter-item-bottom applicationCenter-item-graybg">
                    <div class="applicationCenter-item-fanye">
                        <div style="float:left" class="sedu-portal" @click="prea()">&#xe668;</div>
                        <div style="float:left;margin-left:27px" class="applicationCenter-item-fanye1">0{{this.value+1}}</div>
                        <div style="float:left">/</div>
                        <div style="float:left" class="applicationCenter-item-fanye1">0{{this.size}}</div>
                        <div style="float:right" class="sedu-portal" @click="next()">&#xe667;</div>
                    </div>
                </div>
            </div>
                <Carousel v-model="value" loop arrow="never" dots="none">
                    <CarouselItem style="float:left" v-for="count in number" :key="count">
                        <div v-for="(item,index) in list " :key="index" @click="jump(item)">
                          <div class="applicationCenter-item applicationCenter-itemhover1" v-if="((index+1)%2 !=0)" >
                            <div class="applicationCenter-itemhover"></div>
                            <div class="applicationCenter-item-top">
                                 <img v-if="!item.image" src="../../static/webp2/应用中心1@2x.webp" style="object-fit: cover;width: 100%;height: 100%;" />
                                 <img v-else :src="item.image" style="object-fit: cover;width: 100%;height: 100%;"/> 

                            </div>
                            <div class="applicationCenter-item-bottom applicationCenter-item-ssanjiao1">
                                <div class="applicationCenter-item-bottom1 ">
                                    <div class="applicationCenter-item-bottom-title">
                                        {{item.title}}
                                    </div>
                                    <div class="applicationCenter-item-bottom-content">
                                        {{item.description}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="applicationCenter-item applicationCenter-itemhover1" v-else>
                            <div class="applicationCenter-itemhover"></div>
                            <div class="applicationCenter-item-top applicationCenter-item-ssanjiao2">
                                <div class="applicationCenter-item-bottom1 ">
                                    <div class="applicationCenter-item-bottom-title">
                                        {{item.title}}
                                    </div>
                                    <div class="applicationCenter-item-bottom-content">
                                        {{item.description}}
                                    </div>
                                </div>
                            </div>
                            <div class="applicationCenter-item-bottom">
                         
                                    <img v-if="!item.image" src="../../static/webp2/应用中心3@2x.webp" style="object-fit: cover;width: 100%;height: 100%;" />
                                    <img v-else :src="item.image" style="object-fit: cover;width: 100%;height: 100%;"/> 

              
                                
                            </div>
                        </div>  
                        </div>
                                               
                    </CarouselItem>
                </Carousel>
        </div>
    </div>
</template>

<script>
 import casjump from '../common/casjump'
export default {
    components:{

        },
    data(){
        return{
            navList:[],
            list:[],
            number: 0,
            begin: 0,
            end: 4,
            value: 0,
            size: 0,
        }
    },
    mixins:[casjump],
    mounted(){
        this.getNav()
    },
   methods:{
     getNav() {
          GMS.$http.get('/appcenter/getAppCenter').then(res => {
               if( res.status == 200 ){
                    this.navList = res.data
                    this.number = Math.ceil(res.data.length / 4)
                    this.list = this.navList.slice(this.begin, this.end)
                    this.size = this.navList.length
               }
           }).catch(error => {
                  this.$Message.error("获取数据异常，请联系管理员");
        })
      },
      
      prea() {
        if(this.value == 0){
            return
        }
        this.list = this.navList.slice(this.begin-4, this.end-4)
        this.begin = this.begin-4
        this.end = this.end-4
        this.value--
      },
      next(){
        if(this.value == this.number-1){
            return
        }
        this.list = this.navList.slice(this.begin+4, this.end+4)
        this.begin = this.begin+4
        this.end = this.end+4
        this.value++
      },
      jump(item) {
        if(item.route){
            if(item.withToken){
                this.casjump(item.route)
            }else{
                window.open(item.route)
            }
        }
      } 
  }
}
</script>

<style lang="less" scoped>
.applicationCenter-wrap{
    width: 100%;
    overflow: hidden;
}
.applicationCenter{
    width: 1200px;
    margin: 0 auto;
    .applicationCenter-item{
        
        width: 320px ;
        float: left;
        position: relative;
        margin-bottom: 80px;
    }
    .applicationCenter-itemhover1:hover .applicationCenter-itemhover{
        cursor: pointer;
        width: 320px !important;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        border: 3px solid #198eec;
        box-shadow: 0 2px 21px 0 rgba(0,0,0,0.22);
        z-index: 1;
        border-radius: 3px;
    }
    .applicationCenter-item-top{
        width: 320px;
        height: 282px;
    }
    .applicationCenter-item-bottom{
        width: 320px;
        height: 282px;
        
    }
    .applicationCenter-item-graybg{
        background: #F7F8FA;
    }
    .applicationCenter-item-top1{
        margin-left: 32px;
        margin-top: 101px;
        height: 80px;
        float: left;
    }
    .applicationCenter-item-fanye{
        width: 138px;
        height: 28px;
        margin-top: 127px;
        float: left;
        margin-left: 81px;
        line-height: 28px;
    }
    .applicationCenter-item-fanye1{
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 20px;
        color: #0081E9;
        letter-spacing: -0.08px;
        line-height: 30px;
    }
    .applicationCenter-item-top-bg1{
        background: #fff none no-repeat center center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        background-image: url('../../static/webp2/应用中心1@2x.webp');
        // background-size: 300px 282px;
    }
    .applicationCenter-item-top-bg3{
        background: #fff none no-repeat center center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        background-image: url('../../static/webp2/应用中心3@2x.webp');
    }
    .applicationCenter-item-ssanjiao1{
       position: relative;
    }
    .applicationCenter-item-ssanjiao2{
       position: relative;
    }
    .applicationCenter-item-ssanjiao1:after {
        width: 0;
        height: 0;
        left: 50px;
        bottom: 100%;
        content: "";
        position: absolute;
        border-left: 16px solid transparent;
        border-right:16px solid transparent;
        border-bottom: 16px solid #fff;
    }
    .applicationCenter-item-ssanjiao2:after {
        top: 100%;
        width: 0;
        height: 0;
        left: 50px;
        content: "";
        position: absolute;
        border-left: 16px solid transparent;
        border-top:16px solid #fff;
        border-right: 16px solid transparent;
    }
    .applicationCenter-item-bottom1{
        width: 250px;
        height: 100%;
        margin-left: 25px;
        padding-top: 90px;
    }
    .applicationCenter-item-bottom-title{
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 20px;
        color: #232323;
        letter-spacing: -0.08px;
        line-height: 28px;
        margin-bottom: 10px;
    }
    .applicationCenter-item-bottom-content{
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 15px;
        color: #A4A4A4;
        letter-spacing: -0.06px;
        text-align: justify;
        line-height: 24px;
    }
    .applicationCenter-item-bottom-bg2{
        background: #fff none no-repeat center center;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
        background-image: url('../../static/webp2/应用中心2@2x.webp');
    }
    .shuxingwenzi{
        margin-left: 215px;
        padding-top: 300px;
        width: 246px;
        font-size: 12px;
        line-height: 17px;
        transform:rotate(90deg);
        -ms-transform:rotate(90deg); /* IE 9 */
        -moz-transform:rotate(90deg); /* Firefox */
        -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
        -o-transform:rotate(90deg); /* Opera */
        color: #232323;
        font-weight: 300;
    }
    .shuxiangline{
        height: 1px;
        width: 80px;
        background: #D8D8D8;
        float: right;
        margin-top: 7px;
    }
    .applicationCenter-item-bottom-more{
        position: relative;
    }
    .applicationCenter-item-bottom-bg3{
        position: absolute;
        left: 0;
        top: 0;
        height: 282px;
        width: 2000px;
        background: #F7F8FA;
        z-index: -1;
    }
    .applicationCenter-item-bottom-more1{
        float: left;
        width: 140px;
        height: 28px;
        margin-left: 100px;
        margin-top: 127px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 20px;
        color: #222222;
        letter-spacing: 0;
        line-height: 28px;
    }
    @media screen and (max-width:1500px){
        .applicationCenter-item{
            width: 240px !important;
        }
        .applicationCenter-item-fanye{
            margin-top: 127px;
            margin-left: 81px;
        }
        .applicationCenter-item3{
            display: none;
        }
         .applicationCenter-itemhover1:hover .applicationCenter-itemhover{
            width: 240px !important;
        }
        .applicationCenter-item-top{
            width: 240px !important;
        }
        .applicationCenter-item-bottom{
             width: 240px !important;
        }
        .applicationCenter-item-bottom1{
            margin-left: 5px !important;
        }
    }
    @media screen and (min-width:1500px) and (max-width:1800px){
        .applicationCenter-item{
            width: 280px !important;
        }
        .applicationCenter-item-fanye{
            margin-top: 127px;
            margin-left: 71px;
        }
        .applicationCenter-item3{
            display: block;
        }
        .applicationCenter-itemhover1:hover .applicationCenter-itemhover{
            width: 280px !important;
        }
        .applicationCenter-item-top{
            width: 280px !important;
        }
        .applicationCenter-item-bottom{
             width: 280px !important;
        }
        
        
    }
    @media screen and (min-width:1800px){
        .applicationCenter-item{
            width: 320px;
        }
        .applicationCenter-item-fanye{
            margin-top: 93px;
            margin-left: 71px;
        }
        .applicationCenter-item3{
            display: block;
        }
        .applicationCenter-itemhover1:hover .applicationCenter-itemhover{
            width: 316px;
        }
        
    }
}
@media screen and (max-width:1500px){
    .applicationCenter{
        width: 1200px;
    }
}
@media screen and (min-width:1500px) and (max-width:1800px){
    .applicationCenter{
        width: 1400px;
    }
}
@media screen and (min-width:1800px){
    .applicationCenter{
        width: 1600px;
    }
}
.sedu-portal{
    cursor: pointer;
    position: relative;
	z-index: 11;
}
</style>



// WEBPACK FOOTER //
// src/components/applicationCenterS.vue